package fr.frux.navigation

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import fr.frux.core.designsystem.components.FruxNavigationRail

/**
 * Rail grand écran (spec 2026-09-10, §4) : même liste de destinations que [BottomNavigation]
 * ([fruxNavItems]), même règle de sélection appliquée par l'appelant (dernier onglet vu pendant
 * une animation de sortie). L'habillage vit dans le design system ([FruxNavigationRail]).
 */
@Composable
fun RailNavigation(
    currentRoute: Route,
    onNavigate: (Route) -> Unit,
    onAddTreeClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    FruxNavigationRail(
        items = fruxNavItems(),
        isSelected = { it.route == currentRoute },
        onSelect = { onNavigate(it.route) },
        onAddClick = onAddTreeClick,
        modifier = modifier,
    )
}
